import BadgeBox from './BadgeBox';

export default BadgeBox;
